export default __webpack_public_path__ + "static/9-c9ee9c36f39e4ef2581c15269c43f839.jpg";